(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-filters"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["zenyth-carousel"] && !Shopify.designMode) return;
  try {
    
class ZenythCarousel {
  constructor(element) {
    this.carousel = element;
    this.wrapper = element.querySelector('.znt-flex-carousel_wrapper');
    this.slides = Array.from(element.querySelectorAll('.znt-flex-carousel_slide'));
    this.dots = Array.from(element.querySelectorAll('.znt-flex-carousel_dot-control'));
    this.prevButton = element.querySelector('.znt-flex-carousel_prev');
    this.nextButton = element.querySelector('.znt-flex-carousel_next');
    this.autoplayButton = element.querySelector('.znt-flex-carousel_autoplay');
    this.liveRegion = element.querySelector('.znt-flex-carousel_live-region');
    
    this.currentSlide = 0;
    this.slideCount = this.slides.length;
    this.autoplayDelay = parseInt(element.dataset.autoplayDelay) || 5000;
    
    // Generate unique storage key for this carousel instance
    this.storageKey = `zenyth-carousel-${this.carousel.dataset.sectionId || 'default'}`;
    
    // Load autoplay state from localStorage
    this.loadAutoplayState();
    
    this.init();
  }
  
  // LocalStorage methods for persisting autoplay state
  loadAutoplayState() {
    try {
      const savedState = localStorage.getItem(this.storageKey);
      
      if (savedState) {
        const state = JSON.parse(savedState);
        this.isAutoplaying = state.isAutoplaying || false;
        this.wasManuallyPaused = state.wasManuallyPaused || false;
        this.autoplayInterval = null; // Will be set when autoplay starts
      } else {
        // Default state if nothing saved
        this.isAutoplaying = false;
        this.wasManuallyPaused = false;
        this.autoplayInterval = null;
      }
    } catch (error) {
      // Fallback to default state if localStorage fails
      this.isAutoplaying = false;
      this.wasManuallyPaused = false;
      this.autoplayInterval = null;
    }
  }
  
  saveAutoplayState() {
    try {
      const state = {
        isAutoplaying: this.isAutoplaying,
        wasManuallyPaused: this.wasManuallyPaused,
        timestamp: Date.now()
      };
      localStorage.setItem(this.storageKey, JSON.stringify(state));
    } catch (error) {
      // Silently handle localStorage errors
    }
  }
  
  init() {
    if (this.slideCount <= 1) return;
    
    this.bindEvents();
    this.updateSlideVisibility();
    this.updateDots();
    
    // If autoplay should be active, set aria-live to off immediately and update button
    if (this.isAutoplaying && this.carousel.dataset.autoplay === 'true') {
      this.liveRegion.setAttribute('aria-live', 'off');
      // Update button to show pause state immediately
      if (this.autoplayButton) {
        this.updateAutoplayButton();
      }
      
      // Start autoplay immediately for saved state (no delay needed)
      this.startAutoplay();
    } else {
      // Use a small delay to ensure DOM is fully ready for other cases
      setTimeout(() => {
        if (this.isAutoplaying && this.carousel.dataset.autoplay !== 'true') {
          this.isAutoplaying = false;
          this.wasManuallyPaused = false;
          this.saveAutoplayState();
          if (this.autoplayButton) {
            this.updateAutoplayButton();
          }
        } else {
          // Still update the button to reflect the loaded state
          if (this.autoplayButton) {
            this.updateAutoplayButton();
          }
        }
      }, 100);
    }
  }
  
  bindEvents() {
    // Bind methods to preserve context and allow proper cleanup
    this.boundPreviousSlide = this.previousSlide.bind(this);
    this.boundNextSlide = this.nextSlide.bind(this);
    this.boundToggleAutoplay = this.toggleAutoplay.bind(this);
    this.boundHandleKeyPress = this.handleKeyPress.bind(this);
    this.boundGoToSlide = (index) => this.goToSlide(index);
    
    if (this.prevButton) {
      this.prevButton.addEventListener('click', this.boundPreviousSlide);
      this.prevButton.addEventListener('keydown', this.boundHandleKeyPress);
    }
    
    if (this.nextButton) {
      this.nextButton.addEventListener('keydown', this.boundHandleKeyPress);
      this.nextButton.addEventListener('click', this.boundNextSlide);
    }
    
    if (this.autoplayButton) {
      this.autoplayButton.addEventListener('click', this.boundToggleAutoplay);
      this.autoplayButton.addEventListener('keydown', this.boundHandleKeyPress);
    }
    
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.boundGoToSlide(index));
      dot.addEventListener('keydown', this.boundHandleKeyPress);
    });
    
    // Note: Removed hover and focus autoplay pause/resume to prevent aria-live toggling
    // Autoplay only pauses/resumes when user explicitly toggles the button
  }
  
  handleKeyPress(event) {
    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        if (event.target === this.prevButton) {
          this.previousSlide();
        } else if (event.target === this.nextButton) {
          this.nextSlide();
        } else if (event.target === this.autoplayButton) {
          this.toggleAutoplay();
        } else if (this.dots.includes(event.target)) {
          const index = parseInt(event.target.dataset.slideIndex);
          this.goToSlide(index);
        }
        break;
      case 'ArrowLeft':
        if (event.target === this.prevButton || event.target === this.nextButton || this.dots.includes(event.target)) {
          event.preventDefault();
          this.previousSlide();
        }
        break;
      case 'ArrowRight':
        if (event.target === this.prevButton || event.target === this.nextButton || this.dots.includes(event.target)) {
          event.preventDefault();
          this.nextSlide();
        }
        break;
      case 'Home':
        if (this.dots.includes(event.target)) {
          event.preventDefault();
          this.goToSlide(0);
        }
        break;
      case 'End':
        if (this.dots.includes(event.target)) {
          event.preventDefault();
          this.goToSlide(this.slideCount - 1);
        }
        break;
    }
  }
  
  goToSlide(index, isAutoplay = false) {
    if (index < 0 || index >= this.slideCount) {
      return;
    }
    
    this.currentSlide = index;
    this.updateSlideVisibility();
    this.updateDots();
    this.updateLiveRegion(`Showing slide ${index + 1} of ${this.slideCount}`);
    
    // Only pause autoplay when manually navigating (not during autoplay)
    if (this.isAutoplaying && !isAutoplay) {
      this.stopAutoplay();
      this.wasManuallyPaused = true;
      // Save state to localStorage
      this.saveAutoplayState();
    }
  }
  
  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.slideCount;
    this.goToSlide(nextIndex, false); // Mark as manual navigation
    this.updateLiveRegion('Showing next slide');
  }
  
  nextSlideAutoplay() {
    const nextIndex = (this.currentSlide + 1) % this.slideCount;
    this.goToSlide(nextIndex, true); // Mark as autoplay navigation
    this.updateLiveRegion('Showing next slide');
  }
  
  previousSlide() {
    const prevIndex = this.currentSlide === 0 ? this.slideCount - 1 : this.currentSlide - 1;
    this.goToSlide(prevIndex, false); // Mark as manual navigation
    this.updateLiveRegion('Showing previous slide');
  }
  
  updateSlideVisibility() {
    this.slides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        slide.classList.add('znt-flex-carousel_slide--active');
        slide.removeAttribute('hidden');
        slide.setAttribute('aria-hidden', 'false');
      } else {
        slide.classList.remove('znt-flex-carousel_slide--active');
        slide.setAttribute('hidden', '');
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }
  
  updateDots() {
    this.dots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.setAttribute('aria-selected', 'true');
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.setAttribute('aria-selected', 'false');
        dot.setAttribute('aria-current', 'false');
      }
    });
  }
  
  startAutoplay() {
    // Check if we already have an active interval
    if (this.isAutoplaying && this.autoplayInterval) {
      return;
    }
    
    this.isAutoplaying = true;
    this.autoplayInterval = setInterval(() => {
      // Always advance to next slide, which will loop automatically
      this.nextSlideAutoplay();
    }, this.autoplayDelay);
    
    this.updateAutoplayButton();
    this.updateLiveRegion('Carousel autoplay active');
    this.liveRegion.setAttribute('aria-live', 'off');
    
    // Save state to localStorage
    this.saveAutoplayState();
  }
  
  stopAutoplay() {
    if (!this.isAutoplaying) return;
    
    this.isAutoplaying = false;
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
    
    this.updateAutoplayButton();
    this.updateLiveRegion('Carousel paused');
    this.liveRegion.setAttribute('aria-live', 'polite');
    
    // Save state to localStorage
    this.saveAutoplayState();
  }
  
  // Note: Removed pauseAutoplay() and resumeAutoplay() methods
  // since we no longer pause on hover/focus to prevent aria-live toggling
  
  toggleAutoplay() {
    if (this.isAutoplaying) {
      this.stopAutoplay();
      this.wasManuallyPaused = true;
      // Save state immediately after stopping
      this.saveAutoplayState();
    } else {
      this.startAutoplay();
      this.wasManuallyPaused = false;
      // Save state immediately after starting
      this.saveAutoplayState();
    }
  }
  
  updateAutoplayButton() {
    if (!this.autoplayButton) return;
    
    if (this.isAutoplaying) {
      this.autoplayButton.setAttribute('aria-label', 'Pause Carousel');
      this.autoplayButton.innerHTML = `
        <svg class="carousel-icon" width="${this.carousel.style.getPropertyValue('--carousel-icon-size') || '20'}" height="${this.carousel.style.getPropertyValue('--carousel-icon-size') || '20'}" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z" fill="currentColor"/>
        </svg>
      `;
    } else {
      this.autoplayButton.setAttribute('aria-label', 'Play Carousel');
      this.autoplayButton.innerHTML = `
        <svg class="carousel-icon" width="${this.carousel.style.getPropertyValue('--carousel-icon-size') || '20'}" height="${this.carousel.style.getPropertyValue('--carousel-icon-size') || '20'}" viewBox="0 0 24 24" aria-hidden="true">
          <path d="M8 5v14l11-7z" fill="currentColor"/>
        </svg>
      `;
    }
  }
  
  updateLiveRegion(message) {
    if (!this.liveRegion) return;
    
    this.liveRegion.textContent = message;
    
    // Clear message after 2 seconds
    setTimeout(() => {
      if (this.liveRegion.textContent === message) {
        this.liveRegion.textContent = '';
      }
    }, 2000);
  }
  
  
  // Cleanup method for customizer support
  destroy() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
    
    // Remove event listeners
    if (this.prevButton) {
      this.prevButton.removeEventListener('click', this.boundPreviousSlide);
      this.prevButton.removeEventListener('keydown', this.boundHandleKeyPress);
    }
    
    if (this.nextButton) {
      this.nextButton.removeEventListener('keydown', this.boundHandleKeyPress);
      this.nextButton.removeEventListener('click', this.boundNextSlide);
    }
    
    if (this.autoplayButton) {
      this.autoplayButton.removeEventListener('click', this.boundToggleAutoplay);
      this.autoplayButton.removeEventListener('keydown', this.boundHandleKeyPress);
    }
    
    this.dots.forEach((dot, index) => {
      dot.removeEventListener('click', this.boundGoToSlide);
      dot.removeEventListener('keydown', this.boundHandleKeyPress);
    });
  }
}

// Initialize carousels with customizer support
function initializeCarousels() {
  // Remove existing instances to prevent duplicates
  const existingCarousels = document.querySelectorAll('.znt-flex-carousel[data-carousel-initialized="true"]');
  existingCarousels.forEach(carousel => {
    if (carousel.zenythCarouselInstance) {
      // Clean up existing instance if it exists
      if (carousel.zenythCarouselInstance.autoplayInterval) {
        clearInterval(carousel.zenythCarouselInstance.autoplayInterval);
      }
    }
    carousel.removeAttribute('data-carousel-initialized');
    delete carousel.zenythCarouselInstance;
  });

  // Initialize new carousels
  const carousels = document.querySelectorAll('.znt-flex-carousel[aria-roledescription="carousel"]:not([data-carousel-initialized="true"])');
  carousels.forEach(carousel => {
    try {
      const instance = new ZenythCarousel(carousel);
      carousel.zenythCarouselInstance = instance;
      carousel.setAttribute('data-carousel-initialized', 'true');
    } catch (error) {
      // Silently handle initialization errors
    }
  });
}

// Initialize on DOM ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeCarousels);
} else {
  initializeCarousels();
}

// Support for Shopify theme customizer (iframe re-rendering)
if (typeof window.Shopify !== 'undefined' && window.Shopify.designMode) {
  // Listen for customizer events
  document.addEventListener('shopify:section:load', initializeCarousels);
  document.addEventListener('shopify:section:reorder', initializeCarousels);
  document.addEventListener('shopify:section:select', initializeCarousels);
  document.addEventListener('shopify:section:deselect', initializeCarousels);
  
  // Also listen for general customizer updates
  document.addEventListener('shopify:block:select', initializeCarousels);
  document.addEventListener('shopify:block:deselect', initializeCarousels);
}

// Fallback for iframe scenarios (like theme customizer)
if (window.self !== window.top) {
  // We're in an iframe, set up periodic checks for new carousels
  setInterval(() => {
    const uninitializedCarousels = document.querySelectorAll('.znt-flex-carousel[aria-roledescription="carousel"]:not([data-carousel-initialized="true"])');
    if (uninitializedCarousels.length > 0) {
      initializeCarousels();
    }
  }, 1000);
}

  } catch(e) { console.error(e); }
})();
})();
